<template>
  <div :class="compact ? 'busy-rate is-compact' : 'card card-flush h-100 busy-rate'">
    <div :class="compact ? 'busy-rate__head' : 'card-header border-0 pt-5'" :style="compact ? null : 'padding: 2rem 0.4rem;'">
      <h3 :class="compact ? 'busy-rate__title' : 'card-title align-items-start flex-column'">
        <span :class="compact ? '' : 'card-label fw-bolder text-dark'">Taxa de Ocupação</span>
      </h3>
      <div class="d-flex justify-content-around" :class="compact ? 'pt-1' : 'pt-2'">
          <BusyRateLegend />
      </div>
    </div>
    <div :class="compact ? 'busy-rate__body' : 'card-body'" :style="compact ? null : 'padding: 0 5px 0.4rem 5px;'">
        <div class="flex flex-wrap gap-3" :class="{ 'p-fluid': !compact }">
            <div class="flex-auto">
              <Calendar v-model="baseDate"
                        @dateSelect="$emit('onSelectDate', $event)"
                        inline
                        :showWeek="!compact"
                        @monthChange="handleMonthChange">
                <template #date="slotProps">
                  <div v-if="hasEvent(slotProps.date)">
                    <div
                        :style="{ color: getTextColor(slotProps.date), backgroundColor: getBackgoundColor(slotProps.date), padding: '1px', borderRadius: '50%', width: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center'}"
                        :title="`${getEventRate(slotProps.date)}%`">
                      <strong>{{ slotProps.date.day }}</strong>
                    </div>
                  </div>
                  <div v-else>
                    <strong style="text-decoration: line-through">
                      {{ slotProps.date.day }}
                    </strong>
                  </div>
                </template>
              </Calendar>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import http from "../../helpers/http";
import Calendar from "primevue/calendar";
import BusyRateLegend from "./BusyRateLegend.vue";

export default {
  name: "BusyRate",
  props: {
    profId: { default: null },
    specId: { default: null },
    selectedDate: { default: null },
    compact: { type: Boolean, default: false },
  },
  components: {
      BusyRateLegend,
      Calendar,
  },
  data() {
    return {
      events: [],
      baseDate: '',
    }
  },
  watch: {
    profId() {
      this.loadBusyRate(this.baseDate);
    },
    specId() {
      this.loadBusyRate(this.baseDate);
    },
    selectedDate: {
      immediate: true,
      handler(value) {
        if (!value) return;
        const next = this.date(value);
        const previousMonth = this.baseDate ? this.date(this.baseDate).format('YYYY-MM') : null;
        this.baseDate = next.toDate();
        if (previousMonth !== next.format('YYYY-MM')) {
          this.loadBusyRate(next.format('YYYY-MM-DD'));
        }
      },
    },
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  mounted() {
    if (!this.baseDate) {
      this.baseDate = this.date().startOf('month').toDate();
    }
    this.loadBusyRate(this.baseDate);
  },
  methods: {
    date: moment,
    handleMonthChange(newDate) {
      const formattedDate = `${newDate.year}-${(newDate.month).toString().padStart(2, '0')}-01`;
      this.loadBusyRate(formattedDate);
    },
    loadBusyRate(date) {
        if (!this.profId) {
            return;
        }

      const startDate = this.date(date).format('YYYY-MM-DD');
      const endDate = this.date(date).endOf('month').format('YYYY-MM-DD');

      return http.get(`/places/${this.place.id_place}/dashboard/professionals/${this.profId}/busy-rate`, {
        params: {
          id_spec: this.specId,
          start_date: startDate,
          end_date: endDate,
          general: false,
        }
      }).then((response) => {
        this.events = response.data;
      });
    },
    hasEvent(date) {
      const searchDate = this.date(date).format('YYYY-MM-DD');
      return this.events.some(event => event.date === searchDate);
    },
    getBackgoundColor(date) {
      const searchDate = this.date(date).format('YYYY-MM-DD');
      const event = this.events.find(event => event.date === searchDate);

      if (event?.background_color) {
        const {r, g, b} = this.hexToRgb(event.background_color);
        return `rgba(${r}, ${g}, ${b}, ${event.opacity})`;
      }

      return null;
    },
    hexToRgb(hex) {
      let r = 0, g = 0, b = 0;
      if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
      } else if (hex.length === 7) {
        r = parseInt(hex[1] + hex[2], 16);
        g = parseInt(hex[3] + hex[4], 16);
        b = parseInt(hex[5] + hex[6], 16);
      }
      return {r, g, b};
    },
    getTextColor(date) {
      const searchDate = this.date(date).format('YYYY-MM-DD');
      const event = this.events.find(event => event.date === searchDate);
      return event?.text_color;
    },
    getEventRate(date) {
      const searchDate = this.date(date).format('YYYY-MM-DD');
      const event = this.events.find(event => event.date === searchDate);
      return event?.rate;
    },
  },
}

</script>

<style>
.p-calendar {
    max-width: 100%;
    width: 100%;
}

.calendar-container {
    display: flex;
    justify-content: center;
}
.p-datepicker table th {
    padding: 0.1rem;
}

.p-datepicker table td {
    padding: 0.1rem;
}

.busy-rate.is-compact .busy-rate__head {
    padding: 0 0 0.4rem;
}
.busy-rate.is-compact .busy-rate__title {
    font-size: 0.9rem;
    font-weight: 700;
    color: #181c32;
    margin: 0 0 0.35rem;
}
.busy-rate.is-compact .busy-rate__body {
    padding: 0;
}
.busy-rate.is-compact .p-calendar,
.busy-rate.is-compact .p-datepicker {
    width: 100%;
    max-width: 100%;
    min-width: 0 !important;
    padding: 0.25rem 0 0;
    border: 0;
}
.busy-rate.is-compact .p-datepicker-group,
.busy-rate.is-compact .p-datepicker-calendar-container {
    width: 100%;
}
.busy-rate.is-compact .p-datepicker table {
    width: 100%;
    table-layout: fixed;
}
.busy-rate.is-compact .p-datepicker table th,
.busy-rate.is-compact .p-datepicker table td {
    padding: 0.1rem 0;
}
.busy-rate.is-compact .p-datepicker table th {
    text-align: center;
}
.busy-rate.is-compact .p-datepicker table td > div > div {
    width: 1.85rem !important;
    height: 1.85rem;
    margin: 0 auto;
    box-sizing: border-box;
}
.busy-rate.is-compact .badge {
    padding: 0.28em 0.55em !important;
    font-size: 0.72rem;
    font-weight: 700;
}
.busy-rate.is-compact .d-flex {
    flex-wrap: wrap;
    gap: 0.2rem;
    justify-content: flex-start !important;
}
</style>
